/**
 * Catch-all for Clerk's path-routed sign-up steps (`/sign-up/verify-email-address`,
 * `/sign-up/continue`, …). Renders the same card as the door itself (CLA-1032).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { signUpHead, validateLoginSearch } from "~/lib/login-search.ts";
import { ClawInstallSignUp } from "./index.tsx";

export const Route = createFileRoute("/clawinstall/sign-up/$")({
  validateSearch: validateLoginSearch,
  head: () => signUpHead("ClawInstall"),
  component: ClawInstallSignUp,
});
